import { View, Text, TouchableOpacity, ScrollView, Image } from "react-native";
import React, { useEffect, useState } from "react";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { SeparaterView } from "../../../common/CommonView";
import { formatDate } from "../../../utility/Index";
import { CommonButton } from "../../../common/CommonButton";
import { AppImages } from "../../../utility/AppImages";
import { getLoginData } from "../../../utility/AppStoreData";
import { base_url, endpoints, genres } from "../../../Api/configs";
import { toast } from "react-toastify";
import { ShowLoader } from "../../../common/ShowLoader";
import GetTicketModal from "./GetTicket/GetTicketModal";
import AddEventDetails from "./CreateEvents/AddEventDetails";
import CompetitorsModal from "./CreateEvents/CompetitorsModal";
import { AppScreens } from "../../Utility/AppScreens";
import InviteSocialMediaModal from "../Event/InviteSocialMediaModal";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { fetchEventDetails } from "../../../services/eventsAPI";
import HomeCards from "../../../Components/home-common-components/HomeCards";
import Separator from "../../../Components/Separator";
import StreamerViewComponent from "../../../Components/notification-common-components/StreamerViewComponent";
import DescriptionScrollView from "../../../Components/notification-common-components/DescriptionScrollView";
import Skeletons from "../../../Components/skeleton-components/Skeletons";
import ButtonsSkeleton from "../../../Components/skeleton-components/ButtonsSkeleton";
import Header from "./Common/Header";
import { ScreenBGGradientView } from "../../../common/CommonView";

const TicketDetailWebScreen = ({ route }) => {
  const routeData = route.params;
  const navigation = useNavigation();
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [getTicketModal, setTicketModal] = useState(false);
  const [isshare, setIsShare] = useState(false);

  const [userData, setUserData] = useState(null);

  const [showEventDetailLoader, setShowEventDetailLoader] = useState(false);
  const [showRecommendedLoader, setShowRecommendedLoader] = useState(false);

  const [recommendedData, setRecommendedData] = useState([]);
  const [recommendedEmpty, setRecommendedEmpty] = useState(false);
  const [details, setDetails] = useState(undefined);
  const [accessToken, setAccessToken] = useState("");
  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [createEvent, setCreateEvent] = useState(false);
  const [competitorModel, setCompetitorModel] = useState(false);
  const [apiData, setApiData] = useState({});

  useEffect(() => {
    getLoginUserData();
    // const eventId = route.params ? route.params.eventId : '';
    if (routeData != null && routeData.eventID) {
      getEventDetails({ txtSearch: routeData.eventID });
    }
  }, []);

  useEffect(() => {
    if (refreshAPICall) {
      getEventDetails({ txtSearch: routeData.eventID });
      setRefreshAPICall(false);
    }
  }, [refreshAPICall]);

  function getRecommendedEvent(username) {
    setShowRecommendedLoader(true);

    let url = base_url + endpoints.events.eventsRecommended;

    const bodyParams = {
      userID: username,
    };

    return fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        body: bodyParams,
      }),
    })
      .then(async function (data) {
        const responce = await data.json();
        const statusCode = data.status;

        if (statusCode === 200) {
          if (responce.statusCode === 200) {
            if (Array.isArray(responce.body)) {
              responce.body.length === 0
                ? setRecommendedEmpty(true)
                : setRecommendedEmpty(false);
              setRecommendedData(responce.body);
            } else if (Array.isArray(responce.body.events)) {
              responce.body.events.length === 0
                ? setRecommendedEmpty(true)
                : setRecommendedEmpty(false);
              setRecommendedData(responce.body.events);
            }
          } else {
            console.log("API Error:- ", responce.body.error);
            toast.error(responce.body.error);
          }
        } else if (statusCode == 400) {
          toast.error("Bad Request");
        } else if (statusCode > 400 && statusCode < 420) {
          toast.error("Unauthorized");
        } else if (statusCode >= 500) {
          toast.error("Internal Server Error");
        }
      })
      .catch((error) => {
        console.log("Authorization failed: " + error);
        toast.error(error.message);
      })
      .finally(() => {
        setShowRecommendedLoader(false);
      });
  }

  const getEventDetails = async (props) => {
    setShowEventDetailLoader(true);
    const userData = await getLoginData();

    const { txtSearch = "" } = props;

    try {
      const data = await fetchEventDetails(txtSearch, userData.AccessToken);

      if (data && data.eventID) {
        setDetails(data);
      } else {
        console.log("API Error:- ", data.error);
        toast.error(data.error);
      }
    } catch (error) {
      console.log("Authorization failed: " + error.message);
      toast.error(error.message);
    } finally {
      setShowEventDetailLoader(false);
    }
  };

  const defaultImage =
    details && details.eventPicUrl !== ""
      ? details.eventPicUrl
      : "https://squdifi-event-thumbnail.s3.eu-west-2.amazonaws.com/default-event.svg";

  const isOrganiserId =
    details && userData && details?.participantIDs.includes(userData.username);

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen
                // { txtSearch: searchEvent });
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <View style={[styles.container, {}]}>
        <View
          style={{
            height: "7%",
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          {showEventDetailLoader ? (
            <Skeletons
              height={35}
              width={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "200px"
                  : "500px"
              }
              style={{
                borderRadius: 10,
              }}
            />
          ) : (
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_20
                  : AppFontStyle.BOLD_ANYBODY_32,
                {
                  color: AppColors.white,
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                },
              ]}
            >
              {details != null && details.gameTitle ? details.gameTitle : ""}{" "}
            </Text>
          )}
          {/* <TouchableOpacity
            onPress={() => {
              navigateToScreen(navigation, AppScreens.UserProfile);
            }}
            style={{
              justifyContent: "center",
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_14,
                {
                  color: AppColors.white,
                  alignItems: "center",
                  justifyContent: "center",
                  alignSelf: "center",
                },
              ]}
            >
              {userData != null ? userData.username : ""}
            </Text>

            <View
              style={{
                height: "80%",
                aspectRatio: 1,
                backgroundColor: AppColors.appViolentColor_6D08C3,
                borderRadius: 100,
              }}
            ></View>
          </TouchableOpacity> */}
        </View>

        {/* Get tickets / Buttons  */}

        <View
          style={{
            // height: 40,
            justifyContent: "flex-start",
            alignSelf: "flex-start",
            marginTop: 13,
            marginBottom: 20,
            flexDirection: "row",
            flexWrap: "wrap",
            gap: showEventDetailLoader ? 8 : 13,
          }}
        >
          {showEventDetailLoader ? (
            <ButtonsSkeleton number={4} />
          ) : (
            <>
              <CommonButton
                title="Join event"
                onTap={() => {
                  {
                    isOrganiserId
                      ? navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                            eventID: details.eventID,
                          })
                      : navigateToScreen(navigation, AppScreens.GameShowScreen, {
                            eventID: details.eventID,
                          });
                  }
                }}
                buttonStyle={styles.btnGetTicketStyle}
                textStyle={{
                  padding: 0,
                }}
              />
              {details && details.startDateTime && (
                <CommonButton
                  title={
                    details != null && details.startDateTime
                      ? formatDate(details.startDateTime)
                      : ""
                  }
                  buttonStyle={[
                    styles.btnGetTicketStyle,
                    { backgroundColor: AppColors.appViolentColor_6D08C3 },
                  ]}
                  textStyle={{
                    padding: 0,
                  }}
                />
              )}
              {details && details.gameTitle && (
                <CommonButton
                  title={
                    details != null && details.gameTitle
                      ? details.gameTitle
                      : ""
                  }
                  buttonStyle={[
                    styles.btnGetTicketStyle,
                    { backgroundColor: AppColors.appViolentColor_6D08C3 },
                  ]}
                />
              )}
              {details && details.challengeMode && (
                <CommonButton
                  title={
                    details != null && details.challengeMode
                      ? details.challengeMode
                      : ""
                  }
                  buttonStyle={[
                    styles.btnGetTicketStyle,
                    { backgroundColor: AppColors.appViolentColor_6D08C3 },
                  ]}
                />
              )}

              {deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ? null : (
                <TouchableOpacity
                  onPress={() => {
                    setIsShare(true);
                  }}
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 50,
                  }}
                >
                  <Image
                    source={AppImages.icShareCrop}
                    style={{ height: 38, width: 38, bottom: 3 }}
                  />
                </TouchableOpacity>
              )}
            </>
          )}
        </View>

        {/* Separater */}
        <SeparaterView />

        {/* Horizontal selected value */}

        {/* <SelectedValuesComponent
          styles={styles}
          arrPopularGeners={arrPopularGeners}
        /> */}

        <ScrollView>
          <View style={styles.detailViewStyle}>
            <View
              style={{
                flexDirection:
                  // deviceSize === DEVICE_SIZES.XS ||
                  // deviceSize === DEVICE_SIZES.SM
                  //   ? "column"
                  //   :
                  "row",
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 215
                    : "45%",
                gap:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 20,
              }}
            >
              <View style={{ alignItems: "center" }}>
                {showEventDetailLoader ? (
                  <Skeletons
                    height={
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? 128
                        : 186
                    }
                    width={
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? "128px"
                        : "186px"
                    }
                    style={{
                      borderRadius: 10,
                    }}
                  />
                ) : (
                  details && (
                    <Image
                      source={{ uri: defaultImage }}
                      style={{
                        height:
                          deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                            ? 128
                            : 186,
                        width:
                          deviceSize === DEVICE_SIZES.XS ||
                          deviceSize === DEVICE_SIZES.SM
                            ? 128
                            : 186,
                        borderRadius: 10,
                      }}
                      resizeMode="contain"
                    />
                  )
                )}
              </View>

              <DescriptionScrollView
                showLoader={showEventDetailLoader}
                styles={styles}
                heading="Description:"
                details={details}
              />
            </View>
            <StreamerViewComponent
              styles={styles}
              showLoader={showEventDetailLoader}
              setIsShare={setIsShare}
              participants={details?.participantDetails || []}
              attendees={details?.attendeeIDs}
            />
          </View>

          {/* Recommended */}

          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={2}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
          {/* Recommended */}
          <HomeCards
            userData={userData}
            heading="Recommended"
            CardData={recommendedData}
            showLoader={showRecommendedLoader}
            CardDataEmpty={recommendedData.length === 0}
            // setIsGetTicket={false}
            accessToken={accessToken}
          />

          {/* Separater */}
          <Separator
            color={AppColors.appGrayColor_1C1C1C}
            height={2}
            marginTop={0}
            marginBottom={0}
            marginHorizontal={0}
          />
          {/* </ScrollView> */}
        </ScrollView>

        {/* {<ShowLoader showIndicater={showLoader} />} */}
        {isshare && (
          <InviteSocialMediaModal
            accessToken={""}
            challengeDetails={{}}
            eventID={routeData.eventID}
            showModal={isshare}
            setShowModal={setIsShare}
            eventType={"TicketDetailWebScreen"}
            status={details?.status}
          />
        )}
        {getTicketModal && (
          <GetTicketModal
            showModal={getTicketModal}
            setShowModal={setTicketModal}
            details={details}
            userData={userData}
          />
        )}
        {createEvent && (
          <AddEventDetails
            showModal={createEvent}
            setShowModal={setCreateEvent}
            setCompetitorModel={setCompetitorModel}
            setData={setApiData}
            apiData={apiData}
            isUpdate={true}
            userData={userData}
          />
        )}
        {competitorModel && (
          <CompetitorsModal
            showModal={competitorModel}
            setShowModal={setCompetitorModel}
            apiData={apiData}
            setApiData={setApiData}
            accessToken={accessToken}
            setRefreshAPICall={setRefreshAPICall}
            isUpdate={true}
            eventID={routeData.eventID}
          />
        )}
      </View>
    </View>
  );

  async function getLoginUserData() {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
      setAccessToken(data.AccessToken);

      getRecommendedEvent(data.username != null ? data.username : "");
    }
  }
};

export default TicketDetailWebScreen;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    btnGetTicketStyle: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.appGreenColor_51AF07,
      shadowOpacity: 0,
      flexGrow: 1,
      height: 40,
      borderRadius: 10,
    },
    listBgViewStyle: {
      height: 205,
      width: 220,
      gap: 8,
    },
    attendeesBgViewStyle: {
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 7,
      alignSelf: "flex-start",
    },
    streamViewStyle: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      width: "50%",
      borderRadius: 10,
      paddingVertical: 9,
      paddingHorizontal: 11,
      gap: 10,
    },
    detailViewStyle: {
      justifyContent: "space-between",
      flexDirection: "row",
      flex: 1,
      gap: 8,
      marginBottom: 47,
      marginTop: 51,
    },
    detailTextStyle: {
      width: "80%",
      height: 310,
    },
    playersView: {
      flexDirection: "row",
      gap: 10,
      justifyContent: "space-evenly",
    },
    vsImage: {
      width: 225,
      height: 204,
      marginVertical: 10,
    },
    playerView: {
      borderRadius: 12,
      alignItems: "center",
    },
    playerImg: {
      height: 167,
      width: 152,
      marginVertical: 10,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 40,
        borderRadius: 10,
      },
      listBgViewStyle: {
        height: 205,
        width: 220,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      vsImage: {
        width: 100,
        height: 125,
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "50%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      detailViewStyle: {
        justifyContent: "space-evenly",
        flexDirection: "row",
        flex: 1,
        gap: 8,
        marginBottom: 10,
        marginTop: 10,
      },
      detailTextStyle: {
        width: "50%",
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },

      playerImg: {
        height: 90,
        width: 90,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 40,
        borderRadius: 10,
      },
      listBgViewStyle: {
        height: 205,
        width: 220,
        gap: 8,
      },
      vsImage: {
        width: 140,
        height: 125,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "50%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      detailViewStyle: {
        justifyContent: "space-evenly",
        flexDirection: "row",
        flex: 1,
        gap: 8,
        marginBottom: 10,
        marginTop: 10,
      },
      detailTextStyle: {
        width: "50%",
      },
      playersView: {
        flexDirection: "row",
        gap: 5,
      },
      playerImg: {
        height: 100,
        width: 100,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 40,
        borderRadius: 10,
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "50%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      detailViewStyle: {
        justifyContent: "space-evenly",
        flexDirection: "row",
        flex: 1,
        gap: 8,
        marginTop: 10,
        marginBottom: 10,
      },
      detailTextStyle: {
        width: "50%",
        height: 100,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },

      playerImg: {
        height: 96,
        width: 80,
      },
      vsImage: {
        width: 100,
        height: 130,
        marginVertical: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      btnGetTicketStyle: {
        paddingVertical: 0,
        paddingHorizontal: 15,
        backgroundColor: AppColors.appGreenColor_51AF07,
        shadowOpacity: 0,
        flexGrow: 1,
        height: 40,
        borderRadius: 10,
      },
      listBgViewStyle: {
        height: 205,
        width: 185,
        gap: 8,
      },
      attendeesBgViewStyle: {
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 7,
        alignSelf: "flex-start",
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        width: "100%",
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
      },
      detailViewStyle: {
        justifyContent: "space-evenly",
        flexDirection: "column",
        flex: 1,
        gap: 8,
        marginTop: 10,

        marginBottom: 10,
      },
      detailTextStyle: {
        width: "100%",
        height: 100,
      },
      playersView: {
        flexDirection: "row",
        gap: 10,
      },
      playerImg: {
        height: 96,
        width: 80,
      },
      vsImage: {
        width: 100,
        height: 130,
        marginVertical: 10,
      },
    },
  }
);
